/** Hospital sites run on UAE time; playback ranges are entered and shown in it. */
export const SITE_TIME_ZONE = 'Asia/Dubai';

const INPUT_VALUE = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/;

const inputParts = new Intl.DateTimeFormat('en-GB', {
  timeZone: SITE_TIME_ZONE,
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  hourCycle: 'h23',
});

const clockTime = new Intl.DateTimeFormat('en-GB', {
  timeZone: SITE_TIME_ZONE,
  hour: '2-digit',
  minute: '2-digit',
  hourCycle: 'h23',
});

/** Formats an instant as a `datetime-local` value in site time (YYYY-MM-DDTHH:mm). */
export function toSiteInputValue(value: Date): string {
  const parts = Object.fromEntries(
    inputParts.formatToParts(value).map((part) => [part.type, part.value]),
  );
  return `${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}`;
}

/** Reads a `datetime-local` value as site time and returns the instant, or null when invalid. */
export function siteInputToDate(value: string): Date | null {
  if (!INPUT_VALUE.test(value)) return null;
  const wallAsUtc = new Date(`${value}:00Z`);
  if (Number.isNaN(wallAsUtc.getTime())) return null;
  const offset = new Date(`${toSiteInputValue(wallAsUtc)}:00Z`).getTime() - wallAsUtc.getTime();
  return new Date(wallAsUtc.getTime() - offset);
}

/** HH:mm of a site-time `datetime-local` value, or --:-- when it is not a valid value. */
export function formatSiteInputTime(value: string): string {
  const date = siteInputToDate(value);
  return date ? clockTime.format(date) : '--:--';
}
